<template>
  <div class="grid" :class="{ 'grid--wide': gridWide }">
    <div v-if="search" class="xs-12">
      <div class="myhome-booklist-filters">
        <InputText id="autosearch" v-model="searchText" icon="search" placeholder="Ricerca prodotto" />
        <InputSelect
          id="books-order"
          v-model="sortValue"
          placeholder="Ordina per"
          name="books-order"
          class="dea-input--small"
        >
          <option value>Ordina per</option>
          <option value="title_asc">Titolo</option>
          <option value="title_desc">Titolo (inverso)</option>
          <option value="author_asc">Autore</option>
          <option value="author_desc">Autore (inverso)</option>
          <option value="publisher_asc">Casa editrice</option>
          <option value="publisher_desc">Casa editrice (inverso)</option>
        </InputSelect>
      </div>
    </div>
    <div v-for="item in books" :key="item.external_id" :class="columns">
      <CardProduct
        :link="item.link"
        class
        type="book"
        :image="item.image"
        :title="item.title"
        :subtitle="item.subtitle"
        :school-target="item.school_target"
        :author="item.author"
        :editor="item.editor"
        :badge-type="item.badgeType"
        :activation-date="item.activationDate"
        :expiration-date="item.expirationDate"
        :expired="item.expired"
        :suspended="item.suspended"
        :card-type="cardType"
        :target="linkTarget"
        :minisite-link="item.minisite_link"
        :show-extra-info="deascuolaSearch"
        :time-id="item.external_id"
        :show-catalog-link="showCatalogLink"
        :activable="!!item.activable"
        :private="item.private"
        @click="openChildrenBook($event, item)"
      />
    </div>
  </div>
</template>

<script>
import CardProduct from "./ProductCard";
import InputSelect from "../elements/InputSelect";
import InputText from "../elements/InputText";

export default {
  name: "BooksList",
  components: { CardProduct, InputSelect, InputText },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    linkMinisite: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    child: {
      type: String,
      default: null,
    },
    listColumns: {
      type: Number,
      default: 9,
    },
    deascuolaSearch: {
      type: Boolean,
      default: false,
    },
    cardType: {
      type: String,
      default: "normal",
    },
    columnsClass: {
      type: String,
      default: "",
    },
    agent: {
      type: Boolean,
      default: false,
    },
    badgeNew: {
      type: Boolean,
      default: true,
    },
    linkTarget: {
      type: String,
      default: "",
    },
    asyncConf: {
      type: Object,
      required: true,
    },
    gridWide: {
      type: Boolean,
      default: false,
    },
    showCatalogLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortValue: "",
      searchText: "",
      books: this.mapResults(this.items),
      columns: this.columnsClass || `xs-6 s-6 m-${Math.ceil((12 / this.listColumns) * 3)}`,
    };
  },
  watch: {
    listColumns() {
      this.columns = this.columnsClass || `xs-6 s-6 m-${Math.ceil((12 / this.listColumns) * 3)}`;
    },
    items() {
      this.books = this.mapResults(this.items);
    },
    searchText() {
      if (this.searchText) {
        this.books = this.mapResults(
          this.items.filter(x => {
            if (x.license) {
              return x.book.title.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
            }
            return x.title.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
          })
        );
      } else {
        this.books = this.mapResults(this.items);
      }
    },
    sortValue() {
      this.books.sort(this.sortFunction);
    },
  },
  methods: {
    getMinisiteLink(book) {
      if (this.linkMinisite) return `${this.asyncConf.minisiteUrl}${book.external_id}`;
      return "";
    },
    // eslint-disable-next-line consistent-return
    getLink(book, activable) {
      if (book.license) {
        return book.license.link;
      }
      if (this.linkMinisite && this.asyncConf && this.asyncConf.minisiteUrl) {
        const agentProp = this.agent ? "/?agent" : "";
        return `${this.asyncConf.minisiteUrl}${book.external_id}${agentProp}`;
      }
      if (book.url) {
        return book.url;
      }
      if (activable && book.private) {
        return `${this.$root.config.activation_book_url.replace("%(book)s", book.external_id)}?url=${encodeURIComponent(
          document.location.href
        )}`;
      }
      if (this.asyncConf && this.asyncConf.workApi) {
        return `${this.asyncConf.workApi}${book.external_id}`;
      }
    },
    openChildrenBook(event, book) {
      if (this.child) {
        event.preventDefault();
        this.$emit("open-child-book", this.child, book);
      }
    },
    mapResults(results) {
      const books = [];
      let image;
      let badge;
      // eslint-disable-next-line no-restricted-syntax
      for (const item of results) {
        badge = null;
        if (item.license) {
          if (item.book.cover_composition) {
            image = item.book.cover_composition;
          } else if (item.book.images.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            image = item.book.images[0];
          } else {
            image = "/static/img/ima_CardBook.png";
          }
          if (item.license.activation.status === "SUSPENDED") {
            badge = "suspended";
          } else if (item.license.activation && item.license.activation.mode === "EVALUATION") {
            badge = "demo";
          } else if (this.badgeNew && (item.book.flag_new || item.book.new_book)) {
            badge = "new";
          }
          books.push({
            type: item.license.type.toLowerCase(),
            image,
            id: item.book.id,
            external_id: item.book.external_id,
            title: item.book.title,
            subtitle: item.book.subtitle,
            author: null,
            author_sort: item.book.authors_by_surname
              ? item.book.authors_by_surname.map(x => x.surname).join(", ")
              : null,
            editor: null,
            editor_sort: item.book.brand.name,
            link: this.child ? null : this.getLink(item),
            original_link: this.getLink(item),
            minisite_link: this.getMinisiteLink(item),
            badgeType: badge,
            activationDate: item.license.created_at,
            expirationDate: item.license.expiration,
            expired: item.license.expired,
            suspended: item.license.suspended,
          });
        } else {
          if (item.cover_composition) {
            image = item.cover_composition;
          } else if (item.images.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            image = item.images[0];
          } else {
            image = "/static/img/ima_CardBook.png";
          }
          if (this.badgeNew && (item.flag_new || item.new_book)) {
            badge = "new";
          }

          const anyTrue = (final, itemValue) => final || itemValue;
          const activable = item.composition.map(composition => composition.activable).reduce(anyTrue, 0);

          books.push({
            type: "book",
            image,
            id: item.id,
            external_id: item.external_id,
            title: item.title,
            subtitle: item.subtitle,
            author: item.authors.map(x => x.name).join(", "),
            author_sort: item.authors_by_surname ? item.authors_by_surname.map(x => x.surname).join(", ") : null,
            editor: item.brand.name,
            editor_sort: item.brand.name,
            link: this.child ? null : this.getLink(item, activable),
            original_link: this.getLink(item, activable),
            minisite_link: this.getMinisiteLink(item),
            badgeType: badge,
            activationDate: "",
            expirationDate: "",
            expired: false,
            suspended: false,
            private: item.private,
            activable,
          });
        }
      }
      return books;
    },
    sortFunction(term1, term2) {
      let a;
      let b;
      let sorted;
      if (term1.book) {
        a = term1.book;
        b = term2.book;
      } else {
        a = term1;
        b = term2;
      }
      if (this.sortValue === "title_asc") {
        sorted = a.title.toLowerCase() >= b.title.toLowerCase();
      }
      if (this.sortValue === "title_desc") {
        sorted = a.title.toLowerCase() < b.title.toLowerCase();
      } else if (this.sortValue === "author_asc") {
        sorted = a.author_sort.toLowerCase() >= b.author_sort.toLowerCase();
      } else if (this.sortValue === "author_desc") {
        sorted = a.author_sort.toLowerCase() < b.author_sort.toLowerCase();
      } else if (this.sortValue === "publisher_asc") {
        sorted = a.editor_sort.toLowerCase() >= b.editor_sort.toLowerCase();
      } else if (this.sortValue === "publisher_desc") {
        sorted = a.editor_sort.toLowerCase() < b.editor_sort.toLowerCase();
      }
      return sorted ? 1 : -1;
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

.myhome-booklist-filters {
  align-items: flex-start;
  display: flex;
  justify-content: flex-end;
  padding-bottom: $space-large;

  .dea-input__support-message,
  label {
    display: none;
    visibility: hidden;
  }

  .dea-input {
    @include media("<=s") {
      width: 100%;
    }

    margin-bottom: 0;

    label {
      margin-bottom: 0;
    }

    &:first-of-type {
      margin-right: $space-small;
    }
  }

  div:last-child {
    @include media("<=s") {
      margin-top: $space-small;
    }
  }

  [type="text"] {
    background: $dea-color-grey-light;
    border: 0;
    border-radius: 0;
    padding: $space-xm-small $space-small;
  }
}

.custom-columns {
  @include media("<=m") {
    flex: 1 0 calc(20% - #{$space-small});
    max-width: calc(20% - #{$space-small});
  }

  @include media("<900px") {
    flex: 1 0 calc(25% - #{$space-small});
    max-width: calc(25% - #{$space-small});
  }

  @include media("<700px") {
    flex: 1 0 calc(33% - #{$space-small});
    max-width: calc(33% - #{$space-small});
  }

  @include media("<500px") {
    flex: 1 0 calc(50% - #{$space-small});
    max-width: calc(50% - #{$space-small});
  }

  flex: 1 0 calc(20% - #{$space-small});
  margin: $space-x-small;
  max-width: calc(20% - #{$space-small});

  .dea-product-card {
    margin: 0 auto;
  }
}
</style>
